import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GroundFloorIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GroundFloorIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5722 21.915H19.3802V6.1771C19.3802 5.93192 19.2056 5.71817 18.9642 5.66927L5.41833 2.96037C5.28316 2.93313 5.1452 2.96107 5.0303 3.03651C4.91469 3.11335 4.83646 3.2307 4.80922 3.36552C4.80223 3.39975 4.79909 3.43328 4.79909 3.46751V21.915H2.60745C2.3221 21.915 2.08984 22.1469 2.08984 22.4326C2.08984 22.7183 2.3221 22.9502 2.60745 22.9502H21.5722C21.8575 22.9502 22.0895 22.7183 22.0895 22.4326C22.0895 22.1469 21.8575 21.915 21.5722 21.915ZM18.3453 15.8385V21.915H5.83395V15.8385H18.3453ZM18.3453 10.42V14.8032H5.83395V10.42H18.3453ZM18.3453 6.60111V9.38475H5.83395V4.09897L18.3453 6.60111Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.7203 18.1991C12.72 17.8519 12.4374 17.569 12.0902 17.5683C11.7427 17.5683 11.4595 17.8512 11.4595 18.1991C11.4595 18.5463 11.7424 18.8292 12.0899 18.8292C12.4374 18.8292 12.7203 18.5463 12.7203 18.1991Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0045 21.5904C12.0339 21.5938 12.0629 21.5952 12.0915 21.5952C12.2927 21.5952 12.4858 21.5261 12.643 21.3969C12.687 21.3605 12.7275 21.32 12.7645 21.2746C12.7799 21.2558 14.3006 19.2964 14.3006 18.2472C14.3006 17.0946 13.3087 16.1572 12.0898 16.1572C10.8708 16.1572 9.87891 17.0946 9.87891 18.2472C9.87891 19.2943 11.3996 21.2558 11.416 21.2767C11.5638 21.4562 11.773 21.568 12.0045 21.5904ZM10.9141 18.2472C10.9141 17.6653 11.4415 17.1924 12.0898 17.1924C12.7383 17.1924 13.2657 17.6653 13.2657 18.2472C13.2657 18.6139 12.6399 19.7246 12.0901 20.4566C11.54 19.7239 10.9141 18.6146 10.9141 18.2472Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default GroundFloorIcon;
